import { useEffect, useState } from "react";
import { getProfile } from "../../shared/api/user";
import { useNavigate } from "react-router-dom";

export default function ProfilePage() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    getProfile()
      .then(setUser)
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return <div className="p-6 text-center text-gray-500">Загрузка...</div>;
  }

  if (!user) {
    return <div className="p-6 text-center text-red-500">Ошибка загрузки профиля</div>;
  }

  return (
    <div className="max-w-xl mx-auto mt-16 bg-white rounded-3xl shadow-xl overflow-hidden">
      <div className="bg-gradient-to-r from-blue-600 to-indigo-600 p-8 text-white flex flex-col items-center">

        <h1 className="text-2xl font-bold">{user.username || "—"}</h1>
        <p className="text-sm opacity-90">{user.email || "—"}</p>
      </div>

      <div className="p-6 space-y-4 text-gray-700 text-base bg-gray-50">
        <div className="flex flex-col gap-2">
          <span className="text-sm text-gray-500">Имя пользователя</span>
          <span className="font-medium">{user.username || "—"}</span>
        </div>
        <div className="flex flex-col gap-2">
          <span className="text-sm text-gray-500">Электронная почта</span>
          <span className="font-medium">{user.email || "—"}</span>
        </div>
      </div>

      <div className="px-6 py-4 text-base text-center bg-white border-t flex flex-col gap-3 sm:flex-row sm:justify-between">
        <button
          onClick={() => navigate("/profile/edit-profile")}
          className="w-full bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition shadow"
        >
          Редактировать профиль
        </button>
        <button
          onClick={() => navigate("/profile/edit-password")}
          className="w-full bg-amber-500 hover:bg-amber-600 text-white px-4 py-2 rounded-md transition shadow"
        >
          Изменить пароль
        </button>
      </div>
    </div>
  );
}
